import React from "react";
import {
  Bids,
  Top_collection,
  NewseLatter,
  Feature_collections,
} from "../../components/component";
import Hero_7 from "../../components/hero/hero_7";
import Meta from "../../components/Meta";
import Download from "../../components/blog/download";
import Process from "../../components/blog/process";
import Characters from "../../components/characters";
import Faq from "../../components/ico-landing/faq";

const Home_1 = () => {
  return (
    <main>
      <Meta title={null} />
      <Hero_7 />
      <Process />
      <Faq />
      <Characters />
      <NewseLatter />
      <Download />
    </main>
  );
};

export default Home_1;
